import { render, staticRenderFns } from "./register.component.vue?vue&type=template&id=bc1bd79e&scoped=true"
import script from "./register.component.vue?vue&type=script&lang=js"
export * from "./register.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1bd79e",
  null
  
)

export default component.exports